<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="sienit">N</span>
          <input type="text" placeholder="Търсене" v-model="searchMaterials" />
        </div>
        <span class="sienit modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content" v-if="!isComingFromReport">
        <!-- IMPORT TEMPLATE -->
        <div v-if="!materials.length" class="modal-content-template" @click="triggerFileInput()">
          <img
            class="modal-content-template-img desktop"
            src="../../assets/img/table_help.png"
            alt="Структура на таблицата"
          />
          <img
            class="modal-content-template-img mobile"
            src="../../assets/img/table_help_mobile.png"
            alt="Структура на таблицата"
          />
        </div>
        <div
          class="modal-content-item"
          v-for="(material, index) in filteredMaterials"
          :key="`materialModal-${index}-${material.name}`"
          :title="material.name"
        >
          <p>{{material.name}}</p>
          <span class="sienit" @click="deleteMaterial(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="materials.length && !filteredMaterials.length">
          Няма намерени резултати за '
          <strong>{{this.searchMaterials}}</strong>'
        </p>
      </div>
      <div class="modal-content" v-else>
        <p
          v-if="!materials.length"
          class="modal-content-no-results text-align-center"
        >Все още няма добавени материали</p>
        <div
          class="modal-content-item"
          v-for="(material, index) in filteredMaterials"
          :key="`addMaterialsModal-${index}-${material._id}`"
          @click="saveSingle(material)"
          :title="material.name"
        >
          <p>
            {{ material.name }}
            <em>({{ material.unit }})</em>
          </p>
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="materials.length && !filteredMaterials.length">
          Няма намерени резултати за '
          <strong>{{this.searchMaterials}}</strong>'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns-select" v-if="isComingFromReport">
          <button class="btn btn-select" @click="isEditInputModalOpened = true">
            <span class="sienit">L</span>
            Нов материал
          </button>
        </div>
        <div v-else>
          <!-- EMPTY DIV FOR THE SPACE-AROUND RULE TO WORK -->
        </div>
        <div class="btns" v-if="!isComingFromReport">
          <button class="btn btn-excel" @click="triggerFileInput()">
            <span class="sienit">E</span>
            Нов файл
          </button>
          <input ref="uploadMaterials" class="input-hide" type="file" @change="handleFile" />
          <button class="btn btn-new" @click="save()">
            <span class="sienit">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
    <EditInputModal v-if="isEditInputModalOpened" :isComingFromMaterials="true"></EditInputModal>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import EditInputModal from './EditInputModal';
export default {
  components: {
    EditInputModal
  },
  props: [
    'incomingMaterials',
    'isComingFromReport',
    'companyId',
    'projectId',
    'objectId'
  ],
  watch: {
    incomingMaterials() {
      this.initMaterials();
    }
  },
  data() {
    return {
      isEditInputModalOpened: false,
      materials: [],
      searchMaterials: ''
    };
  },
  computed: {
    filteredMaterials() {
      return this.filterMaterials();
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.uploadMaterials.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = e => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            for (let i = 0; i < keys.length; i++) {
              if (
                !(
                  keys[i].toLowerCase().includes('име') ||
                  keys[i].toLowerCase().includes('мерна единица') ||
                  keys[i].toLowerCase().includes('цена')
                )
              ) {
                this.$snotify.error(
                  'Таблицата трябва да има заглавен ред с Име / Мерна единица / Цена (евро)'
                );
                return;
              }
            }
            // ROW OBJECT
            for (let item in rows[row]) {
              // ROW DATA
              this.materials.push({
                name: rows[row][item][Object.keys(rows[row][item])[0]],
                unit: rows[row][item][Object.keys(rows[row][item])[1]],
                price: rows[row][item][Object.keys(rows[row][item])[2]]
              });
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error('Качените файлове трябва да бъдат .xls или .xlsx');
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach(sheetName => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterMaterials() {
      return this.materials.filter(m => {
        return m.name
          .toLowerCase()
          .includes(this.searchMaterials.toLowerCase());
      });
    },
    // Handle added material from EditInput
    handleAdd(newMaterial) {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
      this.$http
        .get(url)
        .then(response => {
          const company = response.data;
          // get index of selected project
          const indexOfProject = company.projects.findIndex(
            p => p._id === this.projectId
          );
          // get index of selected object
          const indexOfObject = company.projects[
            indexOfProject
          ].objects.findIndex(o => o._id === this.objectId);

          company.projects[indexOfProject].objects[
            indexOfObject
          ].materials.unshift(newMaterial);

          // make the post request
          let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

          this.$http
            .put(url, company)
            .then(() => {
              this.$snotify.success('Успешно добавяне на нов материал!');
              this.$parent.$emit('getMaterialsAgain');
            })
            .catch(error => {
              console.log(error);
              this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
            });
        })
        .catch(error => console.log(error));
    },
    deleteMaterial(i) {
      this.materials.splice(i, 1);
    },
    close() {
      this.$parent.$emit('closeAddMaterialsModal');
    },
    saveSingle(m) {
      this.$parent.$emit('saveAddMaterialsModal', {
        name: m.name,
        unit: m.unit,
        price: m.price
      });
    },
    save() {
      this.$parent.$emit('saveAddMaterialsModal', this.materials);
    },
    initMaterials() {
      this.materials = this.$cloneDeep(this.incomingMaterials);

      this.materials.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    }
  },
  mounted() {
    this.initMaterials();
    this.$on('saveMaterialActivityOrMechanization', this.handleAdd);
    this.$on('closeEditInputModal', this.closeEditInputModal);
  },
  destroyed() {
    this.$off('saveMaterialActivityOrMechanization');
  }
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
/* .modal-header {
  background: #17643a;
} */
.desktop {
  display: initial;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
